"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const prefix = "[react-sortful] ";
exports.createNewError = (message) => new Error(prefix + message);
